import { useSearchParams } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { BroadcastForm } from "@/features/broadcast/ui/broadcast-form";
import { ScheduledBroadcasts } from "@/features/broadcast/ui/scheduled-broadcasts";
import { BroadcastHistory } from "@/features/broadcast/ui/broadcast-history";

type TabKey = "compose" | "scheduled" | "sent";

function isTabKey(value: string | null): value is TabKey {
  return value === "compose" || value === "scheduled" || value === "sent";
}

export default function Broadcast() {
  const [searchParams, setSearchParams] = useSearchParams();
  const raw = searchParams.get("tab");
  const activeTab: TabKey = isTabKey(raw) ? raw : "compose";

  const handleTabChange = (value: string) => {
    const next = new URLSearchParams(searchParams);
    if (value === "compose") next.delete("tab");
    else next.set("tab", value);
    setSearchParams(next, { replace: true });
  };

  return (
    <div className="h-full w-full p-6">
      <div className="mb-6 space-y-1">
        <h1 className="text-2xl font-semibold text-gray-900">Broadcast</h1>
        <p className="text-sm text-gray-500">
          Send a push notification to a segment of users by category and tags.
        </p>
      </div>

      <Tabs value={activeTab} onValueChange={handleTabChange}>
        <TabsList>
          <TabsTrigger value="compose">Compose</TabsTrigger>
          <TabsTrigger value="scheduled">Scheduled</TabsTrigger>
          <TabsTrigger value="sent">Sent</TabsTrigger>
        </TabsList>
        <TabsContent value="compose" className="mt-6">
          <BroadcastForm />
        </TabsContent>
        <TabsContent value="scheduled" className="mt-6">
          <ScheduledBroadcasts />
        </TabsContent>
        <TabsContent value="sent" className="mt-6">
          <BroadcastHistory />
        </TabsContent>
      </Tabs>
    </div>
  );
}
